import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import * as GroupActions from 'redux/modules/groups';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as UserActions from 'redux/modules/users';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    created: state.groups.created,
    saveError: state.groups.saveError,
    saveSuccess: state.groups.saveSuccess,
  }),
  dispatch => bindActionCreators({ ...GroupActions }, dispatch)
)
@reduxForm({
  form: 'editGroupForm',
  fields: ['id', 'c_id', 'name'],
  //validate: groupValidation,
  destroyOnUnmount: true
})
export default class GroupForm extends Component {


  render() {

    var self = this;

    const {
      editStop,
      fields: { id, c_id, name },
      formKey,
      handleSubmit,
      invalid,
      submitting,
      resetForm,
      createGroup,
      values,
      created,
      pristine,
      save,
      saveError,
      saveSuccess,
      groupId, t
    } = this.props;

    const styles = require('containers/Groups/AddGroup.scss');

    if (groupId in saveError && saveError.groupId != null) {

      var error = (
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {saveError.groupId}
          <span onClick={() => this.props.goBack()}>
            <i className="fa fa-ban" /> {t("main.back_to_grouplist")}
				  </span>
        </div>);
    } else {
      var error = <span />;
    }

    if (saveSuccess == true) {
      var success = (
        <div className="alert alert-success" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {t("createGroupForm.group_is_updated")}
        </div>);
    } else {
      var success = <span />;
    }

    var tooltip = (
      <Tooltip id="tooltip">
        <b>{t("main.terminate_editing")}</b>
      </Tooltip>
    );

    return (
      <tr className={submitting ? styles.saving : ''} style={this.props.trStyle}>
        <td style={{ position: 'relative' }}>
          <input name="username" type="text" className="form-control" {...name} />
          <button style={{ display: pristine ? 'none' : 'block' }} className="btn btn-success"
            onClick={handleSubmit(() =>
              save(values, this.props.urlParams)
                .then(result => {
                  if (result && typeof result.error === 'object') {
                    return Promise.reject(result.error);
                  }
                  self.props.dispatch(UserActions.clear())
                })
            )}
            disabled={pristine || invalid || submitting}>
            <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> 
            {t("main.modify")}
			  </button>
          {name.error && name.touched && <div className="text-danger">{name.error}</div>}
        </td>

        <td style={{ position: 'relative' }}>

          {this.props.addUser}

          <div style={{ overflow: 'auto', maxHeight: '200px' }}>
            {this.props.users}
          </div>
        </td>

        <td style={{ position: 'relative' }}>
          {this.props.addSite}<br />
          <div style={{ overflow: 'auto', maxHeight: '200px' }}>
            {this.props.gsms}
          </div>
        </td>

        <td>
          {/*this.props.dpBtn*/}
          &nbsp;
          <OverlayTrigger placement="top" overlay={tooltip}>
            <button type="button" className="btn btn-default"
              onClick={() => this.props.handleEditStop(formKey)}
              disabled={submitting}>
              <i className="fa fa-ban" />
            </button>
          </OverlayTrigger>

        </td>

      </tr>
    );
  }
}

